module.exports = __webpack_public_path__ + "static/media/BulkTextToPayScreen.8a4899b8.png";